export const STORIES_LIST_REQUEST = 'STORIES_LIST_REQUEST';
export const STORIES_LIST_SUCCESS = 'STORIES_LIST_SUCCESS';

export const STORY_DETAILS_REQUEST = 'STORY_DETAILS_REQUEST';
export const STORY_DETAILS_SUCCESS = 'STORY_DETAILS_SUCCESS';
export const STORY_SAVE_REQUEST = 'STORY_SAVE_REQUEST';
export const STORY_SAVE_SUCCESS = 'STORY_SAVE_SUCCESS';
export const STORY_DELETE_REQUEST = 'STORY_DELETE_REQUEST';
export const STORY_DELETE_SUCCESS = 'STORY_DELETE_SUCCESS';
